import {Component, inject, OnInit, signal, ChangeDetectionStrategy} from "@angular/core"
import {HdriLight} from "@cm/template-nodes"
import {fetchThrowingErrors} from "@common/helpers/api/fetch"
import {GetHdriDetailsForHdriLightInspectorGQL} from "@template-editor/components/inspectors/hdri-light-inspector/hdri-light-inspector.generated"
import {SelectionPossibilities, ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {formatFileSize} from "@cm/utils/file-size"
import {extensionForContentType} from "@cm/utils"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-hdri-light-inspector",
    templateUrl: "./hdri-light-inspector.component.html",
    styleUrl: "./hdri-light-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class HdriLightInspectorComponent extends BaseInspectorComponent<HdriLight> implements OnInit {
    readonly $hdriIdPossibilities = signal<SelectionPossibilities<number> | undefined>(undefined)

    readonly hdriDetailsGql = inject(GetHdriDetailsForHdriLightInspectorGQL)

    override async ngOnInit() {
        super.ngOnInit()
        const {hdris} = await fetchThrowingErrors(this.hdriDetailsGql)({})
        const hdriPossibilities: SelectionPossibilities<number> = []

        for (const hdri of hdris) {
            if (!hdri) continue
            const {size, width, height, mediaType, originalFileName} = hdri.dataObject ?? {}

            const fileSize = typeof size === "number" ? formatFileSize(size) : ""
            const resolution = width && height ? `${width} x ${height}` : ""
            const extension = (() => {
                try {
                    if (!mediaType) throw new Error("No media type")
                    return extensionForContentType(mediaType)
                } catch (e) {
                    return originalFileName?.split(".").pop() ?? "hdr"
                }
            })()

            const metaText = [fileSize, resolution, extension.toUpperCase()].filter((x) => x.length > 0).join(", ")

            hdriPossibilities.push({
                value: hdri.legacyId,
                name: hdri.name ?? "Unnamed HDRI",
                subTitle: metaText,
            })
        }

        this.$hdriIdPossibilities.set(hdriPossibilities)
    }
}
